import React from 'react';
import './MinibuttonGroup.less';

export const MinibuttonGroup = ({children, isSolid}) => {
	return (
		<ul className={`minibutton-group ${
			isSolid ? 'minibutton-group--solid' : ''
		}`}>
			{children
				.filter(child => !!child)
				.map(child => (<li key={child?.key} className="minibutton-group__item">
					{child}
				</li>))}
		</ul>
	);
};
